"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.assign");

var _pako = _interopRequireDefault(require("pako"));

var _isSameServiceId = _interopRequireDefault(require("../../utils/isSameServiceId"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 数据压缩
var compress = function compress(next) {
  return function (params) {
    var nextData = _pako.default.deflate(JSON.stringify(params.data.filter(_isSameServiceId.default)), {
      to: 'string'
    });

    return next(Object.assign({}, params, {
      data: nextData
    }));
  };
};

var _default = compress;
exports.default = _default;